  <div
    class="px-2 py-1"
    [style.background-color]="accentColor() ? accentColor() + '22' : null"
    [style.border-color]="accentColor() ? accentColor() + '66' : null"
    [class]="variantClass()"
    [class.accent]="accentColor()"
    [class.round]="round()"
    [class.interactable]="interactable()"
    [class.disabled]="disabled()"
  >
  <ng-content></ng-content>
  @if (deletable()) {
    <fa-icon class="ms-3" [icon]="faTimes" (click)="onDelete.emit()"></fa-icon>
  }
</div>
